import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToasterService } from 'angular2-toaster';
import { ConfigService } from 'src/app/services/config.service';
import { LoginService } from 'src/app/services/login.service';

@Component({
  selector: 'app-social-signin-register-number',
  templateUrl: './social-signin-register-number.component.html',
  styleUrls: ['./social-signin-register-number.component.scss']
})
export class SocialSigninRegisterNumberComponent implements OnInit {
  countryCode: any;
  selectedCountryCode: any;
  url: string;
  phoneNum: any = null;
  configJsonObj: any = [];
  cdnURL: string;
  valueofOTP: boolean;
  searchCountryOrCode: any;
  filteredCountry: any;
  popupVisible: boolean =false;
  searchText: any = [];
  filteredListOfMalls: any[] = [];
  selectedMallCode: any = null;
  mallList: any[] = [];
  disableSearch: boolean = false;
  selectedCoutryTelCode: any;
    constructor(private router:Router, private config: ConfigService, private loginService:LoginService, public toasterService:ToasterService) {
      this.config.getLocalStorageData();
     }
  
    ngOnInit() {
      this.getConuntryData();
      //this.url = this.config.cdnURL + '/ImagePath/' + this.config._tid; 
      this.url = this.config.cdnURL + '/CDN/' + this.config._tid; 

    }
  
    onlyNumber(evt) {
      
      //this.checkLength(evt.value.length);
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        return false;
      }
      return true;
    }
  
    
   /**To get Country codes */
   
   getConuntryData() {
    this.loginService.getCountryCode(this.constructor.name).subscribe(result => {
      //console.log(result)
    if(result['message'].code == 0){
      this.countryCode = result['data']['Country_MsT'];
      this.countryCode.forEach(element => {
        element.country_TEL_Code = '+' + element.country_TEL_Code.toString();
        if(element.country_Name == 'India' || element.country_Name == 'INDIA'){
          this.selectedCountryCode = element.Id ;
        }
      })
    }else{
      this.toasterService.pop('error', result['message'].message)
    }

    })

  }

  sendOTP(e) {

    let result = e.validationGroup.validate();
    if(result.isValid){

      this.loginService.verifyMobileSocialSignup(this.phoneNum, this.selectedCountryCode,this.constructor.name).subscribe(result => {
        // console.log(result);
         
        if(result['message'].code == 0){

          this.loginService.sendOTPForSignUp(this.phoneNum, this.selectedCountryCode ,this.constructor.name).subscribe(result => {
            //console.log(result);
      
            if(result['message'].code == 0){
              this.toasterService.pop("success", "OTP Sent Successfully!");
              //this.phoneNum, this.selectedCountryCode 
              this.config.userDetails["mobileNumber"] = this.phoneNum;
              this.config.userDetails["countryCode"] = this.selectedCountryCode;
              let selected = this.countryCode.find((c) => c.Id === this.selectedCountryCode);
              this.selectedCoutryTelCode = selected.country_TEL_Code ;
              this.config.userDetails["countryTeleCode"] = this.selectedCoutryTelCode;

              // this.config.userDetails["mallCode"] = this.selectedMallCode;

              console.log("user data", this.config.userDetails)
              this.router.navigate(['social-signin-verify-otp']);
            }else if(result['message'].code == 1){
              this.toasterService.pop("error", result['message'].message) //Authtoken Invalid
            }else if(result['message'].code == 1005){
              this.toasterService.pop("error","Authtoken not valid!")
            }else if(result['message'].code == 4006){ //1109
              this.toasterService.pop("error","Requested data not found!")
            }else{
              this.toasterService.pop(result['message'].message);
            }
           })
        }else{ //
          this.toasterService.pop("error",result['message'].message);
        }
       })
      
    }
    
  }
 
  

  
   open() {
    this.popupVisible = !this.popupVisible
    this.filteredCountry = this.countryCode;
  }

  closePopup() {
    this.popupVisible = false;
  }
    searchWthCountryOrCode(e) {
   
    if (this.searchCountryOrCode && this.searchCountryOrCode.trim() !== '') {
      let searchValue = this.searchCountryOrCode.toLowerCase();

      let searchedCountry = this.countryCode.filter((item) => {
        let telCode = item.country_TEL_Code != null ? item.country_TEL_Code.toString() : "";
        return (
          item.country_Name.toLowerCase().includes(searchValue) ||
          telCode.includes(searchValue)
        );
      });
      this.filteredCountry = searchedCountry.length > 0 ? searchedCountry : [];
    } else {
      this.filteredCountry = this.countryCode; // reset full list
    }
     
  }
  selectCountry(country) {
    console.log(country)
    this.selectedCountryCode = country.Id;
    // this.selectedCoutryTelCode = country.country_TEL_Code;
    this.closePopup();
  }
  disableCopyPaste(e: any) {
    const inputElement: HTMLInputElement | null = e.element.querySelector("input");
    if (inputElement) {
      inputElement.addEventListener("paste", (ev) => ev.preventDefault());
      inputElement.addEventListener("copy", (ev) => ev.preventDefault());
      inputElement.addEventListener("cut", (ev) => ev.preventDefault());
    }
  }


  }
  
